var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { DisplayManagerProvider } from '../../context/display-manager-context';
import TargettedSystemContext from '../../context/targetted-system-context';
import WindowEventContext from '../../context/window-event-context';
import { TargettedSystems } from '../../helpers/constants';
import { getGeometryStyle } from '../../helpers/styles';
var TabContainer = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  background: ", ";\n  display: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  flex-direction: ", ";\n"], ["\n  ", "\n  background: ", ";\n  display: ", ";\n  justify-content: ",
    ";\n  align-items: ", ";\n  flex-direction: ",
    ";\n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.background;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.justifyContent;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.alignItems;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.flexDirection;
});
var TabContent = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: ", ";\n  flex-grow: ", ";\n  width: ", ";\n"], ["\n  position: ",
    ";\n  flex-grow: ",
    ";\n  width: ",
    ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.content.position;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.content.flexGrow;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.tabNavigator.nav.item.content.width;
});
var TabNavContainer = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n"])));
var StyledDiv = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: 100%;\n  border: 1px solid white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  margin: 5px;\n"], ["\n  height: 100%;\n  border: 1px solid white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  margin: 5px;\n"])));
var StackedWidget = function (props) {
    var identifier = props.identifier, type = props.type, children = props.children, attributes = props.attributes, restProps = __rest(props, ["identifier", "type", "children", "attributes"]);
    var currentIndex = attributes.currentIndex, geometry = attributes.geometry;
    var _a = useState(currentIndex), activeIndex = _a[0], setActiveIndex = _a[1];
    var childWidgets = restProps.childWidgets;
    var _onTabChange = useContext(WindowEventContext)._onTabChange;
    var changeTab = function (tabIndex) {
        var stateObj = {};
        childWidgets.forEach(function (cWidget) {
            stateObj[cWidget.identifier] = true;
        });
        var activeTab = childWidgets[tabIndex];
        if (activeTab) {
            stateObj[activeTab.identifier] = false;
        }
        setTabManager(stateObj);
    };
    var getSelectedTabContent = function () {
        var activeTab = childWidgets[activeIndex];
        return children.find(function (item) { return item.key === activeTab.identifier; });
    };
    useEffect(function () {
        changeTab(activeIndex);
        setSelectedTabContent(getSelectedTabContent());
    }, [activeIndex]);
    useEffect(function () {
        changeTab(currentIndex);
    }, [currentIndex]);
    var clickHandler = function (identifier, index, buttonId) {
        if (index === childWidgets.length) {
            index = 0;
        }
        else if (index === -1) {
            index = childWidgets.length - 1;
        }
        setActiveIndex(index);
        _onTabChange(buttonId);
    };
    var _b = useState(getSelectedTabContent()), selectedTabContent = _b[0], setSelectedTabContent = _b[1];
    var targetSystem = useContext(TargettedSystemContext);
    var _c = useState({}), tabManager = _c[0], setTabManager = _c[1];
    var prevButtonId = identifier + "_prev";
    var nextButtonId = identifier + "_next";
    return (React.createElement(DisplayManagerProvider, { value: tabManager },
        React.createElement(TabContainer, __assign({ id: identifier, geometry: geometry }, restProps, { windowTheme: restProps.windowTheme }), targetSystem !== TargettedSystems.HERMESYS ? (React.createElement(React.Fragment, null,
            React.createElement(TabNavContainer, null,
                React.createElement("button", { id: prevButtonId, onClick: function () {
                        clickHandler(identifier, +activeIndex - 1, prevButtonId);
                    } }, "Prev"),
                React.createElement("button", { id: nextButtonId, onClick: function () {
                        clickHandler(identifier, +activeIndex + 1, nextButtonId);
                    } }, "Next")),
            React.createElement(TabContent, { windowTheme: restProps.windowTheme }, selectedTabContent))) : (React.createElement(TabNavContainer, null,
            React.createElement(StyledDiv, { onClick: function () {
                    clickHandler(identifier, +activeIndex - 1, prevButtonId);
                } },
                React.createElement("img", { height: 15, width: 15, src: require("../../assets/icons/hermesys/Prev_white.png") })),
            React.createElement(TabContent, { windowTheme: restProps.windowTheme }, selectedTabContent),
            React.createElement(StyledDiv, { onClick: function () {
                    clickHandler(identifier, +activeIndex + 1, nextButtonId);
                } },
                React.createElement("img", { height: 15, width: 15, src: require("../../assets/icons/hermesys/next_white.png") })))))));
};
export default StackedWidget;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map